const getUniqueElementsByProp = ({ elements, prop }) => [...new Set(elements?.map(a => a[prop]))];

export default getUniqueElementsByProp;
